import { Color } from "@starrez/starryui";
import styled from "styled-components";

export const Button = styled.button`
    border: none;
    background: transparent;
    cursor: pointer;
    display:flex;
    padding: 2px;
    border-radius: 3px;

    &:disabled {
        opacity: 0.4;
        pointer-events: none
    }

    &:hover:not(:disabled) {
        ${Color.Blue.Regular};
    }
`;
